module.exports = __webpack_public_path__ + "img/part3-7.d739d303.png";